<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      @click:outside="closeModal"
      scrollable
      :fullscreen="$vuetify.breakpoint.xsOnly"
      max-width="560px"
    >
      <v-card>
        <v-card-title>
          <v-spacer />
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-btn id="InfoDialog_close" icon v-on="on" @click="closeModal">
                <v-icon outline>
                  close
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $tc('close') }}</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-row justify="center">
            <v-col cols="8" class="ma-2 mb-4">
              <v-img
                :src="$vuetify.theme.dark ? require('@/assets/images/logo_dinamo_high_light.png') : require('@/assets/images/logo_dinamo_high_dark.png')"
              />
            </v-col>
          </v-row>

          <template>
            <v-card flat class="pa-6">
              <v-row>
                <template v-for="(item, key) in infoItens">
                  <template v-if="item.data !== null && item.data !== ''">
                    <v-col
                      cols="12"
                      :md="item.id === 'copyright_heading' ? 12 : 6"
                      :key="`tab-item-${key}`"
                      v-if="item.data !== null && item.data !== ''"
                      class="pa-2 py-0"
                    >
                      <span
                        class="subtitle-1 font-weight-medium"
                        :id="`title-${item.id}`"
                      >
                        {{ item.title }}
                      </span>
                      <template v-if="Array.isArray(item.data)">
                        <v-row no-gutters class="pt-8" :class="{'hide-in-percy': item.hideFromPercy}">
                          <v-col cols="12" md="6" :id="`subVal-${item.id}`" v-for="subitem in item.data" :key="subitem" :class="item.class">
                            <template v-if="subitem !== null && subitem !== ''">
                              {{ subitem }}
                            </template>
                          </v-col>
                        </v-row>
                      </template>
                      <template v-else>
                        <div :class="{'hide-in-percy': item.hideFromPercy}">
                          <p :id="`val-${item.id}`" v-if="item.html" v-html="item.data" :class="item.class" />
                          <p :id="`val-${item.id}`" v-if="!item.html" class="subtitle-1">
                            {{ item.data }}
                          </p>
                        </div>
                      </template>
                    </v-col>
                  </template>
                </template>
              </v-row>
            </v-card>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  created () {
    this.makeRequests()
  },
  props: {
    open: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  data () {
    return {
      dialog: this.open
    }
  },
  computed: {
    softwares () {
      return this.$store.state.hsm.copyrightInfo
    },
    p11Info () {
      return this.$store.state.hsm.p11Info
    },
    infoItens () {
      if (!this.p11Info) return
      let mode
      if (this.p11Info.hsm_op_mode === 0) mode = 'NRM'
      else if (this.p11Info.hsm_op_mode === 1) mode = 'RM1'
      else if (this.p11Info.hsm_op_mode === 2) mode = 'RM2'
      const items = [
        {
          title: this.$tc('console_version'),
          data: this.$store.state.ui.version,
          id: 'console_version'
        },
        {
          title: this.$tc('serial_number'),
          data: this.p11Info.serialNumber,
          id: 'serial_number'
        },
        {
          title: this.$tc('hardware_version'),
          data: this.p11Info.hardwareVersion,
          hideFromPercy: true,
          id: 'hardware_version'
        },
        {
          title: this.$tc('firmware_version'),
          data: this.p11Info.firmwareVersion,
          hideFromPercy: true,
          id: 'firmware_version'
        },
        {
          title: this.$tc('tampered'),
          data: this.p11Info.tampered_hsm ? this.$t('yes') : this.$t('no'),
          id: 'tampered'
        },
        {
          title: this.$tc('svmk_fingerprint'),
          data: this.p11Info.SVMK_fingerprint,
          id: 'svmk_fingerprint'
        },
        {
          title: this.$tc('model'),
          data: this.p11Info.model,
          id: 'model'
        },
        {
          title: this.$tc('operation_mode'),
          data: mode,
          id: 'mode'
        }
      ]
      if (this.p11Info.ds_bound) {
        items.push(
          {
            title: this.$tc('ds_hsm'),
            data: this.p11Info.ds_hsm,
            id: 'ds_hsm'
          },
          {
            title: this.$tc('ds_account'),
            data: this.p11Info.ds_account,
            id: 'ds_account'
          }
        )
      }
      items.push(
        {
          title: this.$tc('copyright_heading'),
          data: this.softwares,
          id: 'copyright_heading'
        }
      )
      return items
    }
  },
  methods: {
    closeModal () {
      this.dialog = false
      this.$emit('close')
    },
    makeRequests () {
      this.$store.dispatch('hsm/getP11Info')
      this.$store.dispatch('hsm/getCopyrightInfo')
    }
  },
  watch: {
    open (val) {
      this.dialog = val
    }
  }
}
</script>
